module.exports = __webpack_public_path__ + "img/monitor-04.bd8209f8.svg";